
import {getData,postData} from '@/assets/js/api.js'

//账号密码登录
export const doLoginByPassword = (params, fn, cparameter) => {
	let methods = '/api/User/LoginByPassword';
	postData(methods, params, 2, fn, cparameter);
};

//发送登录验证码
export const doSendLoginVerifyCode = (params, fn) => {
  // let methods = '/api/User/SendLoginVerifyCode';
  let methods = '/api/User/SendVerifyCode';
  params["type"] = 0;
	getData(methods, params, 2, fn);
};
//验证码登录
export const doLoginByVerifyCode = (params, fn, cparameter) => {
	let methods = '/api/User/LoginByVerifyCode';
	postData(methods, params, 2, fn, cparameter);
};

//手机验证码登录，自动注册
export const CheckSmsVerifyCodeLogin=(params,fn)=>{
	let methods = '/api/User/CheckSmsVerifyCodeLogin';
	postData(methods, params, 2, fn);
}

//手机验证码登录，自动注册
export const doLoginOrRegisterByCode=(params,fn)=>{
	let methods = '/api/User/LoginOrRegisterByCode';
	postData(methods, params, 2, fn);
}

//注册邮箱验证是否被占用
export const CheckUserId = (params, fn) => {
	let methods = '/api/User/CheckUserId';
	getData(methods, params, 2, fn);
};

//获取当前用户信息
export const GetUserInfo = fn => {
	let methods = '/api/User/GetUserInfo';
	return getData(methods, {}, 1, fn);
};

//发送注册验证码
export const doSendRegisterVerifyCode = (params, fn) => {
	// let methods = '/api/User/SendRegisterVerifyCode';
  let methods = '/api/User/SendVerifyCode';
  params["type"] = 1;
	getData(methods, params, 2, fn);
};

//用户注册
export const doUserRegister=(params, fn)=>{
	let methods = '/api/User/UserRegister';
	postData(methods, params, 2, fn);
}
//账号退出登陆
export const doUserLogout=(params, fn)=>{
	let methods = '/api/User/Logout';
	getData(methods, params, 1, fn);
}
//test
export const FindUserAreaTree = fn => {
	let url = '/api/Area/FindUserAreaTree';
	getData(url, {}, fn);
};

//# 用户列表（含 安装者/业主列表、管理员列表、普通用户列表） fn返回数据
export function doUserList(fn) {
	let url = '/apitest/index.ashx?action=login';
	postData(url, {
		username: '111',
		password: '111'
	}, function(rs) {
		return typeof fn == "function" && fn(rs);
	})
}

export const GetPrivacyPolicy = fn => {
	let url = '/api/common/GetPrivacyPolicy';
	return getData(url, {}, fn);
};

